import { createFileRoute } from '@tanstack/react-router';
import { segmentAudiencesSearchSchema } from './-segment-audiences-search';
import { SegmentAudiencesRoute } from './-route-wrappers';

/**
 * A segment's Ad Audiences tab at its own URL. No `appBundle`: this URL has no `journeys` segment for the
 * resolver to rebuild a target from. The resolver runs inside the flag branch, in
 * `SegmentAudiencesRoute`.
 */
function SegmentAudiencesTabRoute() {
  const { segmentId } = Route.useParams();

  return <SegmentAudiencesRoute segmentId={segmentId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/segments/$segmentId/audiences')({
  component: SegmentAudiencesTabRoute,
  validateSearch: segmentAudiencesSearchSchema,
});
